import rootReducer from './reducers';
import actions from './actions';
import sagas from './sagas';

const reducers = {
  giftcard: rootReducer,
};

export { reducers, actions, sagas };
